export default __webpack_public_path__ + "static/media/shaikhsohel.5b773b3d.jpg";